<template lang="pug">
  #popup-ring.popup__main
    .popup__header
      //- a(href="#" @click.prevent="closePopup").popup__close
    .popup__content
      .popup__title
        p 請開啟音量#[br]以獲得感動體驗
      .popup__agreement
        //- label
        //-   input(type="checkbox" v-model="isAgreed")
        //-   span
        p 台新銀行使用遊戲過程中所偵測之心跳速度數據，僅限用於本網站AI生成音樂用途
      a.popup__button(href="#" @click.prevent="confirm") #[span 我知道了]
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'PopupRing',
  props: {
    playMusic: Function,
  },
  data: () => {
    return {
      isAgreed: true,
    }
  },
  computed: {
    ...mapState(['popup']),
  },
  methods: {
    ...mapActions(['closePopup']),
    confirm() {
      const { isAgreed, playMusic, closePopup } = this;
      if (!isAgreed) {
        this.$toast.error('開始體驗前，請先勾選同意授權心跳速度數據')
        return;
      }
      playMusic();
      closePopup();
      this.$trackEvent('index', 'click_button', 'index_ok');
    }
  },
  mounted() {
  },
  components: {
  }
}
</script>

<style lang="scss">

#popup-ring {

  width: vw(511);
  height: vw(536);
  border: #fff vw(1) solid;
  box-shadow: rgba(#fff, 0.7) inset 0 0 vw(50), rgba(#fff, 0.3) inset 0 0 vw(200), rgba(#ff47bc, 0.5) 0 0 vw(15), rgba(#ff47bc, 0.2) 0 0 vw(50);
  border-radius: vw(10);

  .popup__title {

    padding-top: vw(96);
    padding-bottom: vw(27);

    p {

      color: #fff;
      font-size: vw(36);
      font-weight: 400;
      line-height: lineHeight(36, 60);
      text-align: center;
      letter-spacing: vw(letterSpacing(500, 36));
      padding-left: vw(letterSpacing(500, 36));
      @include narrow-text;
      @include neon-text;

    }

  }

  .popup__agreement {
    position: relative;
    width: vw(384);
    margin-left: vw(70);
    // padding-left: vw(38);
    input {
      position: absolute;
      top: 0;
      left: 0;
      width: 0;
      height: 0;
      opacity: 0;
      cursor: pointer;
    }
    span {
      position: absolute;
      top: vw(5);
      left: 0;
      width: vw(24);
      height: vw(24);
      border: #fff vw(2) solid;
      background: #591f21;
      &::after {
        display: none;
        content: '';
        position: absolute;
        top: vw(3);
        left: vw(3);
        width: vw(13);
        height: vw(13);
        background: url('~@/assets/images/game/part-1/icon-check.png') no-repeat center center / vw(13) vw(13);
        pointer-events: none;
      }
    }
    input:checked ~ span::after {
      display: block;
    }
    p {
      // width: vw(460);
      font-size: vw(22);
      font-weight: 500;
      letter-spacing: vw(letterSpacing(200, 22));
      line-height: lineHeight(18, 28);
    }
  }

  .popup__button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: vw(210);
    height: vw(72);
    color: #fff;
    font-size: vw(30);
    font-weight: 500;
    letter-spacing: vw(letterSpacing(250, 30));
    padding-left: vw(letterSpacing(250, 30));
    margin: vw(41) auto 0;
    padding-bottom: vw(4);
    border-radius: vw(72);
    background: #d70d1a;
    span {
      display: inline-block;
      @include narrow-text;
    }
  }

}

</style>
